import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    ResultInterface,
    ResultPreviewDataInterface,
    ResultPreviewInterface,
    ResultUploadConfirmInterface,
    ResultUploadUrlPostInterface,
    ResultUploadUrlResponseInterface,
} from "../../interfaces";

export const resultActions = createActionGroup({
    source: "result",
    events: {
        create: props<{
            data: FormData;
        }>(),
        preview: props<{
            data: ResultPreviewInterface;
        }>(),
        setResultPreview: props<{
            data: ResultPreviewDataInterface;
        }>(),
        "generate upload url": props<{ data: ResultUploadUrlPostInterface }>(),
        "set upload url data": props<{ data: ResultUploadUrlResponseInterface[] }>(),
        "confirm result upload": props<{ data: ResultUploadConfirmInterface }>(),
        "get result": props<{ id: string; replace?: boolean }>(),
        "set result": props<{ data: ResultInterface }>(),
        "remove result": props<{ id: string }>(),
        "clear data": emptyProps(),
        "download result": props<{ data: string; is_download: boolean }>(),
        "delete result": props<{ id: string, classroomExamId: string }>(),
    },
});
